var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"updated-date-label"},[_c('vs-tooltip',{attrs:{"text":_vm.createdText,"color":"#2D9CDB"}},[_vm._v("\n    "+_vm._s(_vm.updatedText)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }